var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_comment_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_comment_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.589 1.426a5.65 5.65 0 0 0-7.455 7.716l-.671 2.002a.857.857 0 0 0 .954 1.117l2.737-.456a5.647 5.647 0 0 0 7.487-4.019 5.649 5.649 0 0 0-3.052-6.36Zm-5 3.913c0-.296.24-.535.536-.535h4.179a.536.536 0 1 1 0 1.07H4.125a.536.536 0 0 1-.536-.535Zm.536 2.036a.536.536 0 1 0 0 1.071h3.16a.536.536 0 0 0 0-1.071h-3.16Z",
  fill: "#58636A"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_comment_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .625)",
  d: "M0 0h12v12H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_comment_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .625)",
  d: "M0 0h12v12H0z"
})))));
export default SvgWebappComment;